// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qrCode":"qrCode-3mq5b-UF","close":"close-2PpZhJN3"};